import { Reveal, Eyebrow } from "@/components/Reveal";
import { DIFFERENCE } from "@/data/content";

export default function Difference() {
  return (
    <section data-testid="difference-section" className="py-20 sm:py-28 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>Our difference</Eyebrow>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-ink max-w-2xl leading-[1.1] mb-16">
            We understand <span className="font-editorial italic font-medium text-gold-600">you</span> — and your business.
          </h2>
        </Reveal>

        <div className="border-t border-ink/10">
          {DIFFERENCE.map((d, i) => (
            <Reveal key={d.num} delay={0.05 * i}>
              <div
                data-testid={`difference-item-${i}`}
                className="group grid sm:grid-cols-12 gap-4 sm:gap-8 py-10 border-b border-ink/10 items-baseline transition-colors duration-500 hover:bg-gold-50/60 sm:px-6 -mx-2 sm:-mx-6 px-2 rounded-xl"
              >
                <div className="sm:col-span-2 font-display text-sm font-bold tracking-[0.3em] text-gold-600">{d.num}</div>
                <h3 className="sm:col-span-4 font-display text-2xl sm:text-3xl font-bold text-ink">{d.title}</h3>
                <p className="sm:col-span-6 text-ink/55 leading-relaxed">{d.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
